<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useCustomersStore } from '@/stores/customers'
import CustomerSpotlightSearch from '@/components/customers/CustomerSpotlightSearch.vue'
import CustomerDetailPanel from '@/components/customers/CustomerDetailPanel.vue'

const authStore = useAuthStore()
const customersStore = useCustomersStore()

function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false
  const tag = target.tagName
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true
  return target.isContentEditable
}

function onGlobalKeydown(event: KeyboardEvent) {
  if (!authStore.canAccessStaff) return
  if (event.key !== '/' || event.metaKey || event.ctrlKey || event.altKey) return
  if (customersStore.spotlightOpen || isTypingTarget(event.target)) return
  event.preventDefault()
  customersStore.openSpotlight()
}

onMounted(() => {
  window.addEventListener('keydown', onGlobalKeydown)
})

onUnmounted(() => {
  window.removeEventListener('keydown', onGlobalKeydown)
  customersStore.closeSpotlight()
  customersStore.closeDetail()
})
</script>

<template>
  <template v-if="authStore.canAccessStaff">
    <CustomerSpotlightSearch
      :open="customersStore.spotlightOpen"
      :users="customersStore.users"
      :loading="customersStore.loading"
      @close="customersStore.closeSpotlight()"
      @select="customersStore.selectUser"
    />

    <CustomerDetailPanel
      :key="customersStore.selectedUser?.id ?? 'closed'"
      :user="customersStore.selectedUser"
      @close="customersStore.closeDetail()"
    />
  </template>
</template>
